import _ from 'lodash';
import moment from 'moment-timezone';

const getDisabledDatesForSegment = (productSegmentRules, officeTimezone, maxEndDate, disabledDays) => {
  const maxDaysForStarting = _.get(productSegmentRules, 'delayed_start_days', null);
  const disabledDates = [];
  const today = moment.tz(officeTimezone);
  const tomorrow = moment.tz(officeTimezone).add('days', 1);
  const maxEndDatePlusOne = maxEndDate.add('days', 1);
  if (!_.isEmpty(productSegmentRules)) {
    disabledDates.push(today.toDate());
    let bookableCount = 0;
    const currentDay = _.clone(tomorrow);
    while (bookableCount < maxDaysForStarting) {
      if (!disabledDays.includes(currentDay.isoWeekday())) {
        bookableCount += 1;
      }
      currentDay.add(1, 'days');
    }
    while (currentDay <= maxEndDatePlusOne) {
      disabledDates.push(_.clone(currentDay).toDate());
      currentDay.add(1, 'days');
    }
  }
  return disabledDates;
};

export default getDisabledDatesForSegment;
